// Block of the overlay and the fade element
var loaderOverlay = document.getElementsByClassName("loader-overlay")[0];
var loaderOverlayContent = document.getElementsByClassName("loader-overlay__content")[0];
var loaderOverlayCover = document.getElementsByClassName("loader-overlay__cover")[0];
var fadeElement = document.getElementsByClassName("loader-overlay__content__overlay")[0];
var hideBlueSloop = document.getElementsByClassName("blue-sloop")[0];
/* Display the overlay with the loader and set the session to not display this anymore until
  the current window/tab closes
*/

if (window.sessionStorage.getItem("hideLoaderOverlay")) {
    // Remove a layout catch on load first
    // it doesn't work 100% yet, but it has a low concern.
    hideBlueSloop.classList.remove("blue-sloop--hide");
    loaderOverlayCover.style.display = "none";


    // Hide the splash overlay indefinately
    loaderOverlay.style.display = "none";
}
else {
    if (loaderOverlayContent) {
        fireLayoutOverlay();
    }
}

function fireLayoutOverlay() {
    const bodymovin = require("./vendor/lottie");

    /* To prevent a little background image seizure on load with the browser first loading
      the layout overlay and then hide it when it notices it's not neeeded anymore,
      this is hidden by default
     */
    loaderOverlayContent.classList.add("loader-overlay__content--show");

    // Initialize the animation of the text
    var animation = bodymovin.loadAnimation({
        container: document.getElementById("t4sLoaderOverlay"),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: '/animations/data.json'
    });

    /* This is a function to get the URL of the background image to create a pseudo img
      element. As this is the same file, we can use this to add an event listener to
      check if the image (as we can't check that for background images) has fully loaded
      to afterwards start the animations
    */
    function getBgUrl(el) {
        var bg = "";
        if (el.currentStyle) { // IE
            bg = el.currentStyle.backgroundImage;
        } else if (document.defaultView && document.defaultView.getComputedStyle) { // Firefox
            bg = document.defaultView.getComputedStyle(el, "").backgroundImage;
        } else { // try and get inline style
            bg = el.style.backgroundImage;
        }
        return bg.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
    }

    var fauxImage = document.createElement('img');
    var bottomLogo = document.getElementsByClassName("loader-overlay__content__bottom-logo")[0];
    var bgImage = document.getElementsByClassName("loader-overlay__content__image")[0];
    fauxImage.src = getBgUrl(bgImage);

    fauxImage.onload = function () {
        // Show the background image after it has loaded to prevent seeing it load slowly
        bgImage.classList.add("loader-overlay__content__image--show");

        // Trigger the zoom in/scale animation
        bgImage.classList.add('loader-overlay__content__image--scale');

        // Display the bottom logo
        bottomLogo.style.display = "block";

        // Trigger the dark semi-transparent overlay
        fadeElement.classList.add("loader-overlay__content__overlay--fade");

        // Play the bodymovin animation of the text
        animation.play();

        // Check within sessionStorage to not show this again
        window.sessionStorage.setItem('hideLoaderOverlay', 'true');

        // remove the inline background styling in the body to prevent viewing the blue body background image
        // it doesn't work 100% yet, but it has a low concern.
        loaderOverlayCover.style.display = "none";
        hideBlueSloop.classList.remove("blue-sloop--hide");

        /* When the animations of the text and the image have finished, add this 'hide'
          modifier class to trigger the animation to hide the overlay
        */
        animation.addEventListener('complete', function() {
            loaderOverlay.classList.add("loader-overlay--hide");
        });
    };
    // Finally, empty the now redundant image element
    if (typeof fauxImage.remove === 'function') {
        fauxImage.remove();
    } else {
        // Internet explorer doesn't support remove(), but it does support removeChild()
        bgImage.appendChild(fauxImage);
        fauxImage.parentNode.removeChild(fauxImage);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/loader.js